var _style, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVertWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.3 320.2",
    style: {
      enableBackground: "new 0 0 47.3 320.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#247D91;}\n\t.st2{fill:#003E4C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000016792960537037345330000005639569681634217088_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_03.Dotted-lines"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.2,
    className: "st0",
    width: 8.6,
    height: 266.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.8,266.5h-8.5v-12h8.5V266.5z M29.8,242.5h-8.5v-12h8.5V242.5z M29.8,218.5h-8.5v-12h8.5V218.5z  M29.8,194.4h-8.5v-12h8.5V194.4z M29.8,170.4h-8.5v-12h8.5V170.4z M29.8,146.4h-8.5v-12h8.5V146.4z M29.8,122.4h-8.5v-12h8.5 V122.4z M29.8,98.4h-8.5v-12h8.5V98.4z M29.8,74.4h-8.5v-12h8.5V74.4z M29.8,50.4h-8.5v-12h8.5V50.4z M29.8,26.4h-8.5v-12h8.5 V26.4z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M21,310.4c-0.7-0.3-1.3-0.7-1.8-1.2c-0.7-0.6-1.3-1.2-1.9-1.8c-0.6-0.6-1.1-1.3-1.6-2.1c-0.1,0-0.2,0-0.3,0 h-0.3c-1.6,0.1-3.2-0.3-4.7-1.1c-1.2-0.7-2-1.8-2.5-3.1c-0.5-1.6-0.8-3.2-0.7-4.8v-10.3c0-1.6,0.2-3.2,0.7-4.8 c0.5-1.3,1.3-2.3,2.5-3c1.4-0.7,3-1.1,4.7-1c1.6-0.1,3.3,0.2,4.7,1c1.1,0.7,2,1.7,2.5,3c0.5,1.5,0.8,3.2,0.8,4.8v10.3 c0,1.2-0.1,2.4-0.4,3.6c-0.2,1-0.6,1.9-1.2,2.8c-0.6,0.8-1.3,1.4-2.2,1.8l0.9,1c0.3,0.3,0.6,0.7,1,1c0.3,0.3,0.6,0.5,0.9,0.7 L21,310.4z M15,301.6c0.7,0.1,1.3-0.1,1.9-0.5c0.4-0.4,0.7-0.9,0.8-1.5c0.1-0.7,0.2-1.4,0.2-2.1v-12.7c0-0.7-0.1-1.4-0.2-2.1 c-0.1-0.6-0.4-1.1-0.8-1.4c-0.5-0.4-1.2-0.6-1.9-0.5c-0.7,0-1.3,0.1-1.8,0.5c-0.4,0.4-0.7,0.9-0.8,1.4c-0.1,0.7-0.2,1.4-0.2,2.1 v12.7c0,0.7,0.1,1.4,0.2,2.1c0.1,0.6,0.4,1.1,0.8,1.5C13.7,301.5,14.4,301.7,15,301.6L15,301.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M29.4,313.2c-1.1,0.1-2.1-0.4-2.7-1.3c-0.7-1.2-1-2.7-0.9-4.1v-4.6c0-0.9,0.1-1.9,0.3-2.8 c0.2-0.8,0.6-1.4,1.1-2c0.6-0.5,1.3-0.8,2.1-0.7c0.5,0,1,0.1,1.5,0.3c0.5,0.2,0.9,0.5,1.3,0.8v-7h3.5v21.1h-3.5v-1.1 c-0.4,0.4-0.8,0.7-1.3,1C30.4,313.1,29.9,313.2,29.4,313.2z M30.7,310.7c0.2,0,0.4,0,0.7-0.1c0.3-0.1,0.5-0.2,0.8-0.4v-9.6 c-0.2-0.1-0.4-0.3-0.7-0.3c-0.2-0.1-0.5-0.1-0.8-0.1c-0.4,0-0.8,0.3-1,0.7c-0.2,0.5-0.3,1.1-0.3,1.7v5.6c0,0.5,0,0.9,0.1,1.3 c0,0.4,0.2,0.7,0.4,1C30.1,310.6,30.4,310.7,30.7,310.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVertWhite);
export default __webpack_public_path__ + "static/media/vertWhite.24b85160e47d571fdaab899eed8825bf.svg";
export { ForwardRef as ReactComponent };